module.exports = __webpack_public_path__ + "img/header-flower.a288702f.jpg";